import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <div><FormattedMessage id='common.UNAUTHORIZED' /></div>;
